module.exports = __webpack_public_path__ + "static/media/no-poets-dont-own-words2.6c571570.jpg";